import httpClient from "./httpClient";

const PatientService = {
  async findByAnnouncement(announcementId) {
    const response = await httpClient.get(`/patient/get-by-announcement/${announcementId}`);
    return response.data;
  },

  async create(entity) {
    return await httpClient.post("/patient", entity);
  },

  async update(id, entity) {
    return await httpClient.put(`/patient/${id}`, entity);
  },

  async findById(id) {
    const response = await httpClient.get(`/patient/${id}`);
    return response.data;
  },

  async getVitals(id) {
    const response = await httpClient.get(`/patient/${id}/vitals`);
    return response.data;
  },

  async getBodyMarkers(id) {
    const response = await httpClient.get(`/patient/${id}/body-markers`);
    return response.data;
  },

  async getTreatments(id) {
    const response = await httpClient.get(`/patient/${id}/treatments`);
    return response.data;
  },

  async getOrders(id) {
    const response = await httpClient.get(`/patient/${id}/orders`);
    return response.data;
  },

  async getEvents(id) {
    const response = await httpClient.get(`/patient/${id}/events`);
    return response.data;
  },

  async deleteBodyMarker(id, markerId) {
    const response = await httpClient.delete(`/patient/${id}/body-markers/${markerId}`);
    return response.data;
  }
};

export default PatientService;
